module.exports = __webpack_public_path__ + "assets/img/szjz_1.4cf5f797.png";